import pricingrules from './pricingrules';
import pricingrule from './pricingrule';

export default {
  namespaced: true,
  modules: {
    pricingrules,
    pricingrule,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pricingrules/index.js